import {I18n} from '@aws-amplify/core';
import {NavLink} from 'react-router-dom';
import {Box, Breadcrumbs, Code} from '@mantine/core';

import {moduleConfig} from '../config';

// Takes the id rather than the record, so the not-found and error states can render
// the same breadcrumbs back to the list.
export const EditPageNavigation = ({id}: { id: string }) => {

    const breadcrumbs = [
        {title: I18n.get('Home'), href: '/dashboard'},
        {title: I18n.get(moduleConfig.titles.plural), href: moduleConfig.basePath},
        {title: <Code>{id}</Code>},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
